module.exports = __webpack_public_path__ + "media/images/icons/document_front-ae27f3134f0d638534ef1ad96fd54ce0.png";